import { Device, DeviceInfo } from '@capacitor/device';
import { isNativeApp } from '@/utils/native-app';

let deviceId: string = null;
let deviceInfo: DeviceInfo = null;

export const getDeviceId = async (): Promise<string> => {
  if (!deviceId) {
    if (isNativeApp) {
      const { identifier } = await Device.getId();
      deviceId = identifier;
    } else {
      deviceId = await getBrowserFingerprintId();
    }
  }

  return deviceId;
};

export const getDeviceInfo = async (): Promise<DeviceInfo> => {
  if (deviceInfo === null) {
    deviceInfo  = await Device.getInfo();
    delete deviceInfo.platform;
    delete deviceInfo.memUsed;
    delete deviceInfo.diskFree;
    delete deviceInfo.realDiskFree;
    delete deviceInfo.realDiskTotal;
  }

  return deviceInfo;
};

const getBrowserFingerprintId = async (): Promise<string> => {
  const FingerprintJS = await import('@fingerprintjs/fingerprintjs');
  const fp = await FingerprintJS.load();
  const { visitorId } = await fp.get();

  return visitorId;
};
